// extracted by mini-css-extract-plugin
module.exports = {"s1dwy82k":"s1dwy82k","selected":"selected","current":"current"};